<template>
    <InstagramIcon id="instagram-icon"></InstagramIcon>
</template>

<script>
import InstagramIcon from '@/assets/img/instagram-icon.svg'
export default {
  name: 'InstagramAnimation',
  components: {
    InstagramIcon
  }
}
</script>

<style lang="scss">
#instagram-icon{
    overflow: visible!important;
    #instagram-normal{
        transform: scale(0.5);
        transform-origin: bottom;
        z-index: 1;
    }
    #we-icon{
        opacity: 0;
        transform: scale(0.5);
        transform-origin: bottom;
        z-index: 2;
    }
    &:hover{
        #we-icon{
            animation: weAnimationFadeIn 0.5s cubic-bezier(0.17, 0.88, 0.32, 1.27) forwards;
            animation-delay: 0.4s;
            #borde-burbuja{
                animation: bordeBurbuja 1.5s linear infinite;
            }
        }
    }
}

@keyframes weAnimationFadeIn {
    100% { opacity : 0.9; transform: scale(0); }
    100% { opacity : 1; transform: scale(1.4) translate(-10px, -50px);  }
}
@keyframes bordeBurbuja{
    0% { transform: rotate(0deg) translateX(2px) rotate(0deg); }
    100%   { transform: rotate(360deg) translateX(2px) rotate(-360deg); }
}
</style>
